// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createNote } from './noteSlice';

export interface INoteState {
  isRefreshNoteList: boolean;
}

export const initialState: INoteState = {
  isRefreshNoteList: false,
};

const noteSlice = createSlice({
  name: 'note',
  initialState,
  reducers: {
    setRefreshNoteList(state, action) {
      state.isRefreshNoteList = action.payload;
    },
  },
  extraReducers(builder) {
    // POST: Create note
    builder
      .addCase(createNote.pending, (_state) => {})
      .addCase(createNote.fulfilled, (state) => {
        state.isRefreshNoteList = true;
      })
      .addCase(createNote.rejected, (_state) => {});
  },
});

// Action
export const noteActions = noteSlice.actions;

// Selectors
// Reducer
const noteReducer = noteSlice.reducer;
export default noteReducer;
